import { motion } from "framer-motion";
import { useLang } from "../i18n";

const CHAPTER_IMGS = [
  "https://images.unsplash.com/photo-1629154168869-95c8e955eaed?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1779366034018-46311978eb66?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1662398673920-842dd728ae97?auto=format&fit=crop&w=1400&q=80",
];

export const Manifesto = () => {
  const { t } = useLang();
  const chapters = [
    { n: "01", title: t("manifesto.ch1t"), text: t("manifesto.ch1d") },
    { n: "02", title: t("manifesto.ch2t"), text: t("manifesto.ch2d") },
    { n: "03", title: t("manifesto.ch3t"), text: t("manifesto.ch3d") },
  ];

  return (
    <section id="gevgelija" data-testid="manifesto-section" className="bg-coal text-sand py-24 md:py-36">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16 md:mb-24"
        >
          <p className="text-ember text-xs font-bold tracking-[0.35em] uppercase mb-4">{t("manifesto.kicker")}</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-none">{t("manifesto.title")}</h2>
        </motion.div>

        <div className="space-y-20 md:space-y-28">
          {chapters.map((ch, i) => (
            <motion.div
              key={ch.n}
              initial={{ opacity: 0, y: 48 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center`}
            >
              <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2 md:col-start-8" : ""}`}>
                <div className="spotlight-frame aspect-[4/3] border border-sand/10">
                  <img src={CHAPTER_IMGS[i]} alt={ch.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
              </div>
              <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-1 md:col-start-1" : "md:col-start-7"}`}>
                <span className="font-serif italic text-6xl md:text-8xl text-ember/40 leading-none">{ch.n}</span>
                <h3 className="font-serif text-3xl md:text-4xl tracking-tight mt-4 mb-5">{ch.title}</h3>
                <p className="text-sand/65 text-sm md:text-base leading-relaxed max-w-lg">{ch.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
